package twist.mena.sports.admin.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import twist.mena.sports.admin.theme.*

@Composable
fun Topbar(
    pageTitle: String,
    isDark: Boolean,
    onToggleTheme: () -> Unit,
    userEmail: String?,
    onLogout: () -> Unit,
    sidebarWidth: CSSpxValue = 240.px
) {
    val colors = AppTheme.colors
    var showUserMenu by remember { mutableStateOf(false) }

    Div({
        style {
            property("position", "fixed")
            property("top", "0")
            property("left", "$sidebarWidth")
            property("right", "0")
            height(64.px)
            backgroundColor(Color(colors.surface))
            property("border-bottom", "1px solid ${colors.border}")
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.SpaceBetween)
            padding(0.px, Spacing.xxl)
            property("z-index", "1025")
            themeTransition()
        }
    }) {
        Span({
            style {
                fontSize(Typography.xxl)
                fontWeight("700")
                color(Color(colors.text))
            }
        }) { Text(pageTitle) }

        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                gap(Spacing.sm)
            }
        }) {
            // Theme toggle
            Button({
                onClick { onToggleTheme() }
                style {
                    background("none")
                    border(0.px)
                    cursor("pointer")
                    padding(Spacing.sm)
                    property("border-radius", BorderRadius.circle)
                    color(Color(colors.textMuted))
                    fontSize(Typography.lg)
                    width(40.px)
                    height(40.px)
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    property("transition", "background-color 0.2s ease")
                }
            }) {
                Text(if (isDark) "☀️" else "🌙")
            }

            // User menu
            if (userEmail != null) {
                Div({
                    style { property("position", "relative") }
                }) {
                    Button({
                        onClick { showUserMenu = !showUserMenu }
                        style {
                            background("none")
                            border(1.px, LineStyle.Solid, Color(colors.border))
                            cursor("pointer")
                            padding(Spacing.sm, Spacing.lg)
                            borderRadius(BorderRadius.md)
                            color(Color(colors.text))
                            fontSize(Typography.sm)
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            gap(Spacing.sm)
                            property("transition", "background-color 0.2s ease")
                        }
                    }) {
                        val displayEmail = if (userEmail.length > 24) userEmail.take(22) + "..." else userEmail
                        Text(displayEmail)
                    }

                    if (showUserMenu) {
                        Div({
                            style {
                                property("position", "absolute")
                                property("top", "100%")
                                property("right", "0")
                                marginTop(Spacing.xs)
                                backgroundColor(Color(colors.surface))
                                border(1.px, LineStyle.Solid, Color(colors.border))
                                borderRadius(BorderRadius.md)
                                property("box-shadow", Shadow.md)
                                property("z-index", "1030")
                                minWidth(160.px)
                                overflow("hidden")
                            }
                        }) {
                            Button({
                                onClick {
                                    showUserMenu = false
                                    onLogout()
                                }
                                style {
                                    width(100.percent)
                                    background("none")
                                    border(0.px)
                                    cursor("pointer")
                                    padding(Spacing.md, Spacing.lg)
                                    color(Color(colors.danger))
                                    fontSize(Typography.sm)
                                    display(DisplayStyle.Flex)
                                    alignItems(AlignItems.Center)
                                    gap(Spacing.sm)
                                    textAlign("left")
                                    property("transition", "background-color 0.2s ease")
                                }
                            }) {
                                Text("Logout")
                            }
                        }
                    }
                }
            }
        }
    }

    // Click-away listener
    if (showUserMenu) {
        Div({
            onClick { showUserMenu = false }
            style {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                width(100.vw)
                height(100.vh)
                property("z-index", "1024")
            }
        })
    }
}
